export enum TabList {
  UtilizeMoney = "Utilize Money",
  History = "History"
}
